import moment from 'moment';

export function DateStringToDefaultDateTimeFilter(value: string) {
  return moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss');
}
